import {
  WorkspaceConfig_ManagedRetention_Override,
  WorkspaceConfig_ManagedRetention_Schema,
} from '@/types/api';
import {
  ManagedRetentionOverrideSchemaValues,
  ManagedRetentionSchemaValues,
} from '@/zod/schemas/workspaceConfig/ManagedRetentionSchema';

export const getManagedRetentionInitialSchemaValues = (
  schema: WorkspaceConfig_ManagedRetention_Schema | undefined,
): ManagedRetentionSchemaValues => {
  return {
    schema: schema?.schema || '',
    catalog: schema?.catalog || '',
    column: schema?.column || '',
    duration: schema?.duration || '',
  };
};

export const getNewManagedRetentionSchema =
  (): WorkspaceConfig_ManagedRetention_Schema => {
    return {
      schema: '',
      catalog: '',
    };
  };

export const setManagedRetentionSchema = (
  values: ManagedRetentionSchemaValues,
  schema?: WorkspaceConfig_ManagedRetention_Schema,
): WorkspaceConfig_ManagedRetention_Schema => {
  return {
    schema: values.schema,
    catalog: values.catalog,
    column: values.column,
    duration: values.duration,
    overrides: schema?.overrides || undefined,
  };
};

export const getManagedRetentionInitialOverrideValues = (
  override: WorkspaceConfig_ManagedRetention_Override | undefined,
): ManagedRetentionOverrideSchemaValues => {
  return {
    table: override?.table || '',
    column: override?.column || '',
    duration: override?.duration || '',
  };
};

export const getNewManagedRetentionOverride =
  (): WorkspaceConfig_ManagedRetention_Override => {
    return {
      table: '',
    };
  };

export const setManagedRetentionOverride = (
  values: ManagedRetentionOverrideSchemaValues,
): WorkspaceConfig_ManagedRetention_Override => {
  return {
    table: values.table,
    column: values.column,
    duration: values.duration,
  };
};
